import { Button } from '@hub/shared'
import { useTranslation } from 'react-i18next'
import './footer.scoped.scss'

const Footer = ({ loadingSubmit, videoSelected, onOpenEvent, onSubmit }) => {
  const [t] = useTranslation('overlayContentVideo')
  return (
    <div className="footer">
      <Button
        onClick={() => onOpenEvent(false)}
        disabled={loadingSubmit}
        color="var(--background_secondary)"
        borderColor="var(--gray)"
        textColor="var(--text_color)"
        inverted
      >
        {t('cancel')}
      </Button>
      <Button onClick={() => onSubmit()} loading={loadingSubmit} disabled={loadingSubmit || !videoSelected}>
        {t('save')}
      </Button>
    </div>
  )
}

export default Footer
